import { useState } from 'react';
import {
  getErrorMessage,
  LoadingKeys,
  loadingInitial,
  errorInitial,
} from './common';

export function useVantifyBase() {
  const [loading, setLoading] =
    useState<Record<LoadingKeys, boolean>>(loadingInitial);
  const [error, setError] =
    useState<Record<LoadingKeys, string | null>>(errorInitial);

  const execute = async <T>(
    key: LoadingKeys,
    operation: () => Promise<T>,
    fallbackMessage: string
  ): Promise<T | null> => {
    setLoading(l => ({ ...l, [key]: true }));
    setError(e => ({ ...e, [key]: null }));

    try {
      return await operation();
    } catch (err) {
      const msg = getErrorMessage(err, fallbackMessage);

      setError(e => ({ ...e, [key]: msg }));

      return null;
    } finally {
      setLoading(l => ({ ...l, [key]: false }));
    }
  };

  return { loading, error, execute, setError, setLoading };
}
